import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ImageToolsApp from './components/ImageToolsApp';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import NotFound from './pages/NotFound';
import Header from './components/Header';
import Footer from './components/Footer';

// Tool pages
import CompressImage from './pages/tools/CompressImage';
import ResizeImage from './pages/tools/ResizeImage';
import CropImage from './pages/tools/CropImage';
import ConvertImage from './pages/tools/ConvertImage';
import QrCodeGenerator from './pages/tools/QrCodeGenerator';
import PasswordGen from './pages/tools/PasswordGen';
import UnitConvert from './pages/tools/UnitConvert';
import TimestampConvert from './pages/tools/TimestampConvert';
import NumberBaseConvert from './pages/tools/NumberBaseConvert';
import ColorConvert from './pages/tools/ColorConvert';
import Base64Convert from './pages/tools/Base64Convert';
import UrlEncode from './pages/tools/UrlEncode';
import JsonYamlConvert from './pages/tools/JsonYamlConvert';
import TextCaseConvert from './pages/tools/TextCaseConvert';
import BmiCalc from './pages/tools/BmiCalc';
import LoanCalc from './pages/tools/LoanCalc';
import PercentageCalc from './pages/tools/PercentageCalc';
import CompoundInterestCalc from './pages/tools/CompoundInterestCalc';
import RemoveBg from './pages/tools/RemoveBg';
import ImageOcrPage from './pages/tools/ImageOcrPage';
import HeicToJpgPage from './pages/tools/HeicToJpgPage';
import WebpConverterPage from './pages/tools/WebpConverterPage';
import BlurImagePage from './pages/tools/BlurImagePage';
import PhotoFiltersPage from './pages/tools/PhotoFiltersPage';
import RotateFlipPage from './pages/tools/RotateFlipPage';
import ImageWatermarkPage from './pages/tools/ImageWatermarkPage';
import GrayscalePage from './pages/tools/GrayscalePage';
import SharpenPage from './pages/tools/SharpenPage';
import RoundImagePage from './pages/tools/RoundImagePage';
import ColorPickerPage from './pages/tools/ColorPickerPage';
import ImageToBase64Page from './pages/tools/ImageToBase64Page';
import SvgToPngPage from './pages/tools/SvgToPngPage';
import RemoveExifPage from './pages/tools/RemoveExifPage';
import PixelatePage from './pages/tools/PixelatePage';
import SepiaPage from './pages/tools/SepiaPage';
import InvertPage from './pages/tools/InvertPage';
import BorderPage from './pages/tools/BorderPage';
import SplitterPage from './pages/tools/SplitterPage';
import ProfilePicPage from './pages/tools/ProfilePicPage';
import FaviconPage from './pages/tools/FaviconPage';
import MemePage from './pages/tools/MemePage';
import IcoPage from './pages/tools/IcoPage';
import PalettePage from './pages/tools/PalettePage';
import WordCountPage from './pages/tools/WordCountPage';
import CharCountPage from './pages/tools/CharCountPage';
import LoremPage from './pages/tools/LoremPage';
import DiffPage from './pages/tools/DiffPage';
import MdToHtmlPage from './pages/tools/MdToHtmlPage';
import AgeCalcPage from './pages/tools/AgeCalcPage';
import TipCalcPage from './pages/tools/TipCalcPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ImageToolsApp />} />

          {/* Image Tools */}
          <Route path="/compress-image" element={<CompressImage />} />
          <Route path="/resize-image" element={<ResizeImage />} />
          <Route path="/crop-image" element={<CropImage />} />
          <Route path="/convert-image" element={<ConvertImage />} />
          <Route path="/remove-background" element={<RemoveBg />} />
          <Route path="/image-to-text-ocr" element={<ImageOcrPage />} />
          <Route path="/heic-to-jpg" element={<HeicToJpgPage />} />
          <Route path="/webp-converter" element={<WebpConverterPage />} />
          <Route path="/blur-image" element={<BlurImagePage />} />
          <Route path="/photo-filters" element={<PhotoFiltersPage />} />
          <Route path="/rotate-flip-image" element={<RotateFlipPage />} />
          <Route path="/image-watermark" element={<ImageWatermarkPage />} />
          <Route path="/grayscale-image" element={<GrayscalePage />} />
          <Route path="/sharpen-image" element={<SharpenPage />} />
          <Route path="/round-image" element={<RoundImagePage />} />
          <Route path="/color-picker-from-image" element={<ColorPickerPage />} />
          <Route path="/image-to-base64" element={<ImageToBase64Page />} />
          <Route path="/svg-to-png" element={<SvgToPngPage />} />
          <Route path="/remove-exif" element={<RemoveExifPage />} />
          <Route path="/pixelate-image" element={<PixelatePage />} />
          <Route path="/sepia-filter" element={<SepiaPage />} />
          <Route path="/invert-colors" element={<InvertPage />} />
          <Route path="/add-border" element={<BorderPage />} />
          <Route path="/image-splitter" element={<SplitterPage />} />
          <Route path="/profile-picture-maker" element={<ProfilePicPage />} />
          <Route path="/favicon-generator" element={<FaviconPage />} />
          <Route path="/meme-generator" element={<MemePage />} />
          <Route path="/image-to-ico" element={<IcoPage />} />
          <Route path="/color-palette-extractor" element={<PalettePage />} />

          {/* Text Tools */}
          <Route path="/word-counter" element={<WordCountPage />} />
          <Route path="/character-counter" element={<CharCountPage />} />
          <Route path="/lorem-ipsum-generator" element={<LoremPage />} />
          <Route path="/text-diff" element={<DiffPage />} />
          <Route path="/markdown-to-html" element={<MdToHtmlPage />} />

          {/* Utilities */}
          <Route path="/qr-code-generator" element={<QrCodeGenerator />} />
          <Route path="/password-generator" element={<PasswordGen />} />

          {/* Converters */}
          <Route path="/unit-converter" element={<UnitConvert />} />
          <Route path="/timestamp-converter" element={<TimestampConvert />} />
          <Route path="/number-base-converter" element={<NumberBaseConvert />} />
          <Route path="/color-converter" element={<ColorConvert />} />
          <Route path="/base64-converter" element={<Base64Convert />} />
          <Route path="/url-encoder" element={<UrlEncode />} />
          <Route path="/json-yaml-converter" element={<JsonYamlConvert />} />
          <Route path="/text-case-converter" element={<TextCaseConvert />} />

          {/* Calculators */}
          <Route path="/bmi-calculator" element={<BmiCalc />} />
          <Route path="/loan-calculator" element={<LoanCalc />} />
          <Route path="/percentage-calculator" element={<PercentageCalc />} />
          <Route path="/compound-interest-calculator" element={<CompoundInterestCalc />} />
          <Route path="/age-calculator" element={<AgeCalcPage />} />
          <Route path="/tip-calculator" element={<TipCalcPage />} />

          {/* Blog */}
          <Route path="/blog" element={<><Header /><BlogList /><Footer /></>} />
          <Route path="/blog/:slug" element={<><Header /><BlogPost /><Footer /></>} />

          {/* 404 */}
          <Route path="*" element={<><Header /><NotFound /><Footer /></>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
